module.exports = __webpack_public_path__ + "img/card-icon.85822b24.svg";